"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../../utils/helpers");
var _GradientButtonsModule = _interopRequireDefault(require("./../../scss/buttons/GradientButtons.module.scss"));
function GradientButton(_ref) {
  let {
    type = "button",
    label = "",
    onClick = () => {},
    varient = 'primary',
    size = 'regular',
    classname = '',
    href = '',
    gradientStartColor = "",
    gradientEndColor = "",
    hoverGradientStartColor = "",
    hoverGradientEndColor = "",
    ...attributes
  } = _ref;
  const varientClass = varient === '' ? "" : "gradient-btn--".concat(varient);
  const sizeClass = size === '' ? "" : "gradient-btn--".concat(size);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, href === '' ? /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    type: type,
    onClick: onClick,
    className: (0, _helpers.classes)([classname, _GradientButtonsModule.default['gradient-btn'], 'gradient-btn', varient === '' ? '' : _GradientButtonsModule.default[varientClass], size === '' ? '' : _GradientButtonsModule.default[sizeClass]]),
    style: gradientStartColor !== '' && gradientEndColor !== '' ? {
      '--gradient': "linear-gradient(180deg, ".concat(gradientEndColor, ", ").concat(gradientStartColor, ", ").concat(gradientStartColor, ",").concat(gradientEndColor, ")")
    } : {}
  }, attributes), label) : /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    href: href,
    className: (0, _helpers.classes)([classname, _GradientButtonsModule.default['gradient-btn'], 'gradient-btn', varient === '' ? '' : _GradientButtonsModule.default[varientClass], size === '' ? '' : _GradientButtonsModule.default[sizeClass]]),
    style: gradientStartColor !== '' && gradientEndColor !== '' ? {
      '--gradient': "linear-gradient(180deg, ".concat(gradientEndColor, ", ").concat(gradientStartColor, ", ").concat(gradientStartColor, ",").concat(gradientEndColor, ")")
    } : {}
  }, attributes), label));
}
var _default = exports.default = GradientButton;